export default {
    methods: {
        saveLike(brandId, likeStatus) {
            console.log(likeStatus);
            let likeBrandData = localStorage.getItem('likeBrandData');
            if (!likeBrandData) {
                likeBrandData = {};
            } else {
                likeBrandData = JSON.parse(likeBrandData);
            }
            likeBrandData[brandId] = likeStatus;
            localStorage.setItem('likeBrandData', JSON.stringify(likeBrandData));
        },
        isLike(brandId) {
            let likeBrandData = localStorage.getItem('likeBrandData');
            if (!likeBrandData) {
                return false;
            } else {
                likeBrandData = JSON.parse(likeBrandData);

                console.log(likeBrandData);
                if (!likeBrandData) {
                    return false;
                }

                if (likeBrandData[brandId]) {
                    return true;
                }
                return false;
            }
        },
        getLikes() {
            let likeBrandData = localStorage.getItem('likeBrandData');
            if (!likeBrandData) {
                return {};
            } else {
                return JSON.parse(likeBrandData);
            }
        },
        clearLikes() {
            localStorage.setItem('likeBrandData', null);
        }
    }
};
